import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Route, Redirect, withRouter } from 'react-router'
import { isAdmin } from '../../ducks'

const ProviderRoute = ({ isAdmin, component: Component, ...rest }) => {
  const renderComponent = props => {
    if (!isAdmin) return <Component {...props} />
    return <Redirect to={{ pathname: '/providers/search' }} />
  }

  return <Route {...rest} render={renderComponent} />
}

ProviderRoute.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
  component: PropTypes.elementType.isRequired,
}

const mapStateToProps = state => ({
  isAdmin: isAdmin(state.account.login.user),
})

export default withRouter(connect(mapStateToProps)(ProviderRoute))
